import React from 'react';

import Button from 'components/shared/Button';
import DropzoneDesc from 'components/shared/FileDropZone/Description';
import FormGroup from 'components/shared/FormAdapters/FormDefault/FormGroup/Base';
import { capitalize } from 'utils/common';

function Upload({
  onOpenModal,
  allowedMimeTypes,
  contentType = 'files',
  buttonActionType = 'upload',
  maxFileSize,
  recommendedFileSize,
  className = '',
}) {
  const buttonText = `${capitalize(buttonActionType)} ${capitalize(contentType)}`;

  return (
    <FormGroup className={className}>
      <DropzoneDesc
        isNoDropzone
        allowedMimeTypes={allowedMimeTypes}
        maxFileSize={maxFileSize}
        recommendedFileSize={recommendedFileSize}
        headComponent={
          <Button htmlType="button" type="default" onClick={onOpenModal}>
            {buttonText}
          </Button>
        }
        contentType={contentType}
      />
    </FormGroup>
  );
}

export default Upload;
